// src/clarigen-types.ts
var contracts = {
  clarityBitcoin: {
    functions: {
      buffToU8: {
        name: "buff-to-u8",
        access: "read_only",
        args: [{ name: "byte", type: { buffer: { length: 1 } } }],
        outputs: { type: "uint128" }
      },
      getReversedTxid: {
        name: "get-reversed-txid",
        access: "read_only",
        args: [{ name: "tx", type: { buffer: { length: 1024 } } }],
        outputs: { type: { buffer: { length: 32 } } }
      },
      getTxid: {
        name: "get-txid",
        access: "read_only",
        args: [{ name: "tx", type: { buffer: { length: 1024 } } }],
        outputs: { type: { buffer: { length: 32 } } }
      },
      innerBuff32Permutation: {
        name: "inner-buff32-permutation",
        access: "read_only",
        args: [
          { name: "target-index", type: "uint128" },
          {
            name: "state",
            type: {
              tuple: [
                { name: "hash-input", type: { buffer: { length: 32 } } },
                { name: "hash-output", type: { buffer: { length: 32 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            tuple: [
              { name: "hash-input", type: { buffer: { length: 32 } } },
              { name: "hash-output", type: { buffer: { length: 32 } } }
            ]
          }
        }
      },
      innerMerkleProofVerify: {
        name: "inner-merkle-proof-verify",
        access: "read_only",
        args: [
          { name: "ctr", type: "uint128" },
          {
            name: "state",
            type: {
              tuple: [
                { name: "cur-hash", type: { buffer: { length: 32 } } },
                { name: "path", type: "uint128" },
                {
                  name: "proof-hashes",
                  type: { list: { type: { buffer: { length: 32 } }, length: 20 } }
                },
                { name: "root-hash", type: { buffer: { length: 32 } } },
                { name: "tree-depth", type: "uint128" },
                { name: "verified", type: "bool" }
              ]
            }
          }
        ],
        outputs: {
          type: {
            tuple: [
              { name: "cur-hash", type: { buffer: { length: 32 } } },
              { name: "path", type: "uint128" },
              {
                name: "proof-hashes",
                type: { list: { type: { buffer: { length: 32 } }, length: 20 } }
              },
              { name: "root-hash", type: { buffer: { length: 32 } } },
              { name: "tree-depth", type: "uint128" },
              { name: "verified", type: "bool" }
            ]
          }
        }
      },
      innerReadSlice: {
        name: "inner-read-slice",
        access: "read_only",
        args: [
          { name: "chunk_size", type: "uint128" },
          {
            name: "input",
            type: {
              tuple: [
                { name: "acc", type: { buffer: { length: 1024 } } },
                { name: "buffer", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" },
                { name: "remaining", type: "uint128" }
              ]
            }
          }
        ],
        outputs: {
          type: {
            tuple: [
              { name: "acc", type: { buffer: { length: 1024 } } },
              { name: "buffer", type: { buffer: { length: 1024 } } },
              { name: "index", type: "uint128" },
              { name: "remaining", type: "uint128" }
            ]
          }
        }
      },
      innerReadSlice1024: {
        name: "inner-read-slice-1024",
        access: "read_only",
        args: [
          { name: "ignored", type: "bool" },
          {
            name: "input",
            type: {
              tuple: [
                { name: "acc", type: { buffer: { length: 1024 } } },
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: {
          type: {
            tuple: [
              { name: "acc", type: { buffer: { length: 1024 } } },
              { name: "data", type: { buffer: { length: 1024 } } },
              { name: "index", type: "uint128" }
            ]
          }
        }
      },
      isBitSet: {
        name: "is-bit-set",
        access: "read_only",
        args: [
          { name: "val", type: "uint128" },
          { name: "bit", type: "uint128" }
        ],
        outputs: { type: "bool" }
      },
      parseBlockHeader: {
        name: "parse-block-header",
        access: "read_only",
        args: [{ name: "headerbuff", type: { buffer: { length: 80 } } }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "merkle-root", type: { buffer: { length: 32 } } },
                  { name: "nbits", type: "uint128" },
                  { name: "nonce", type: "uint128" },
                  { name: "parent", type: { buffer: { length: 32 } } },
                  { name: "timestamp", type: "uint128" },
                  { name: "version", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      parseTx: {
        name: "parse-tx",
        access: "read_only",
        args: [{ name: "tx", type: { buffer: { length: 1024 } } }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ins",
                    type: {
                      list: {
                        type: {
                          tuple: [
                            {
                              name: "outpoint",
                              type: {
                                tuple: [
                                  { name: "hash", type: { buffer: { length: 32 } } },
                                  { name: "index", type: "uint128" }
                                ]
                              }
                            },
                            { name: "scriptSig", type: { buffer: { length: 256 } } },
                            { name: "sequence", type: "uint128" }
                          ]
                        },
                        length: 8
                      }
                    }
                  },
                  { name: "locktime", type: "uint128" },
                  {
                    name: "outs",
                    type: {
                      list: {
                        type: {
                          tuple: [
                            { name: "scriptPubKey", type: { buffer: { length: 128 } } },
                            { name: "value", type: "uint128" }
                          ]
                        },
                        length: 8
                      }
                    }
                  },
                  { name: "version", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readHashslice: {
        name: "read-hashslice",
        access: "read_only",
        args: [
          {
            name: "old-ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "hashslice", type: { buffer: { length: 32 } } }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readNextTxin: {
        name: "read-next-txin",
        access: "read_only",
        args: [
          { name: "ignored", type: "bool" },
          {
            name: "state-res",
            type: {
              response: {
                ok: {
                  tuple: [
                    {
                      name: "ctx",
                      type: {
                        tuple: [
                          { name: "index", type: "uint128" },
                          { name: "txbuff", type: { buffer: { length: 1024 } } }
                        ]
                      }
                    },
                    { name: "remaining", type: "uint128" },
                    {
                      name: "txins",
                      type: {
                        list: {
                          type: {
                            tuple: [
                              {
                                name: "outpoint",
                                type: {
                                  tuple: [
                                    { name: "hash", type: { buffer: { length: 32 } } },
                                    { name: "index", type: "uint128" }
                                  ]
                                }
                              },
                              { name: "scriptSig", type: { buffer: { length: 256 } } },
                              { name: "sequence", type: "uint128" }
                            ]
                          },
                          length: 8
                        }
                      }
                    }
                  ]
                },
                error: "uint128"
              }
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "remaining", type: "uint128" },
                  {
                    name: "txins",
                    type: {
                      list: {
                        type: {
                          tuple: [
                            {
                              name: "outpoint",
                              type: {
                                tuple: [
                                  { name: "hash", type: { buffer: { length: 32 } } },
                                  { name: "index", type: "uint128" }
                                ]
                              }
                            },
                            { name: "scriptSig", type: { buffer: { length: 256 } } },
                            { name: "sequence", type: "uint128" }
                          ]
                        },
                        length: 8
                      }
                    }
                  }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readNextTxout: {
        name: "read-next-txout",
        access: "read_only",
        args: [
          { name: "ignored", type: "bool" },
          {
            name: "state-res",
            type: {
              response: {
                ok: {
                  tuple: [
                    {
                      name: "ctx",
                      type: {
                        tuple: [
                          { name: "index", type: "uint128" },
                          { name: "txbuff", type: { buffer: { length: 1024 } } }
                        ]
                      }
                    },
                    { name: "remaining", type: "uint128" },
                    {
                      name: "txouts",
                      type: {
                        list: {
                          type: {
                            tuple: [
                              { name: "scriptPubKey", type: { buffer: { length: 128 } } },
                              { name: "value", type: "uint128" }
                            ]
                          },
                          length: 8
                        }
                      }
                    }
                  ]
                },
                error: "uint128"
              }
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "remaining", type: "uint128" },
                  {
                    name: "txouts",
                    type: {
                      list: {
                        type: {
                          tuple: [
                            { name: "scriptPubKey", type: { buffer: { length: 128 } } },
                            { name: "value", type: "uint128" }
                          ]
                        },
                        length: 8
                      }
                    }
                  }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readSlice: {
        name: "read-slice",
        access: "read_only",
        args: [
          { name: "data", type: { buffer: { length: 1024 } } },
          { name: "offset", type: "uint128" },
          { name: "size", type: "uint128" }
        ],
        outputs: { type: { response: { ok: { buffer: { length: 1024 } }, error: "uint128" } } }
      },
      readSlice1: {
        name: "read-slice-1",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice128: {
        name: "read-slice-128",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice16: {
        name: "read-slice-16",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice2: {
        name: "read-slice-2",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice256: {
        name: "read-slice-256",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice32: {
        name: "read-slice-32",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice4: {
        name: "read-slice-4",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice512: {
        name: "read-slice-512",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice64: {
        name: "read-slice-64",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readSlice8: {
        name: "read-slice-8",
        access: "read_only",
        args: [
          {
            name: "input",
            type: {
              tuple: [
                { name: "data", type: { buffer: { length: 1024 } } },
                { name: "index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { buffer: { length: 1024 } } }
      },
      readTxins: {
        name: "read-txins",
        access: "read_only",
        args: [
          {
            name: "ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "remaining", type: "uint128" },
                  {
                    name: "txins",
                    type: {
                      list: {
                        type: {
                          tuple: [
                            {
                              name: "outpoint",
                              type: {
                                tuple: [
                                  { name: "hash", type: { buffer: { length: 32 } } },
                                  { name: "index", type: "uint128" }
                                ]
                              }
                            },
                            { name: "scriptSig", type: { buffer: { length: 256 } } },
                            { name: "sequence", type: "uint128" }
                          ]
                        },
                        length: 8
                      }
                    }
                  }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readTxouts: {
        name: "read-txouts",
        access: "read_only",
        args: [
          {
            name: "ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "remaining", type: "uint128" },
                  {
                    name: "txouts",
                    type: {
                      list: {
                        type: {
                          tuple: [
                            { name: "scriptPubKey", type: { buffer: { length: 128 } } },
                            { name: "value", type: "uint128" }
                          ]
                        },
                        length: 8
                      }
                    }
                  }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readUint16: {
        name: "read-uint16",
        access: "read_only",
        args: [
          {
            name: "ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "uint16", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readUint32: {
        name: "read-uint32",
        access: "read_only",
        args: [
          {
            name: "ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "uint32", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readUint64: {
        name: "read-uint64",
        access: "read_only",
        args: [
          {
            name: "ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "uint64", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readVarint: {
        name: "read-varint",
        access: "read_only",
        args: [
          {
            name: "ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "varint", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      readVarslice: {
        name: "read-varslice",
        access: "read_only",
        args: [
          {
            name: "old-ctx",
            type: {
              tuple: [
                { name: "index", type: "uint128" },
                { name: "txbuff", type: { buffer: { length: 1024 } } }
              ]
            }
          }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  {
                    name: "ctx",
                    type: {
                      tuple: [
                        { name: "index", type: "uint128" },
                        { name: "txbuff", type: { buffer: { length: 1024 } } }
                      ]
                    }
                  },
                  { name: "varslice", type: { buffer: { length: 1024 } } }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      reverseBuff32: {
        name: "reverse-buff32",
        access: "read_only",
        args: [{ name: "input", type: { buffer: { length: 32 } } }],
        outputs: { type: { buffer: { length: 32 } } }
      },
      verifyBlockHeader: {
        name: "verify-block-header",
        access: "read_only",
        args: [
          { name: "headerbuff", type: { buffer: { length: 80 } } },
          { name: "expected-block-height", type: "uint128" }
        ],
        outputs: { type: "bool" }
      },
      verifyMerkleProof: {
        name: "verify-merkle-proof",
        access: "read_only",
        args: [
          { name: "reversed-txid", type: { buffer: { length: 32 } } },
          { name: "merkle-root", type: { buffer: { length: 32 } } },
          {
            name: "proof",
            type: {
              tuple: [
                {
                  name: "hashes",
                  type: { list: { type: { buffer: { length: 32 } }, length: 20 } }
                },
                { name: "tree-depth", type: "uint128" },
                { name: "tx-index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      verifyPrevBlock: {
        name: "verify-prev-block",
        access: "read_only",
        args: [
          { name: "block", type: { buffer: { length: 80 } } },
          { name: "parent", type: { buffer: { length: 80 } } }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      verifyPrevBlocks: {
        name: "verify-prev-blocks",
        access: "read_only",
        args: [
          { name: "block", type: { buffer: { length: 80 } } },
          { name: "prev-blocks", type: { list: { type: { buffer: { length: 80 } }, length: 10 } } }
        ],
        outputs: { type: { response: { ok: { buffer: { length: 80 } }, error: "uint128" } } }
      },
      verifyPrevBlocksFold: {
        name: "verify-prev-blocks-fold",
        access: "read_only",
        args: [
          { name: "parent", type: { buffer: { length: 80 } } },
          {
            name: "next-resp",
            type: { response: { ok: { buffer: { length: 80 } }, error: "uint128" } }
          }
        ],
        outputs: { type: { response: { ok: { buffer: { length: 80 } }, error: "uint128" } } }
      },
      wasTxMinedPrev: {
        name: "was-tx-mined-prev?",
        access: "read_only",
        args: [
          {
            name: "block",
            type: {
              tuple: [
                { name: "header", type: { buffer: { length: 80 } } },
                { name: "height", type: "uint128" }
              ]
            }
          },
          { name: "prev-blocks", type: { list: { type: { buffer: { length: 80 } }, length: 10 } } },
          { name: "tx", type: { buffer: { length: 1024 } } },
          {
            name: "proof",
            type: {
              tuple: [
                {
                  name: "hashes",
                  type: { list: { type: { buffer: { length: 32 } }, length: 20 } }
                },
                { name: "tree-depth", type: "uint128" },
                { name: "tx-index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      wasTxMined: {
        name: "was-tx-mined?",
        access: "read_only",
        args: [
          {
            name: "block",
            type: {
              tuple: [
                { name: "header", type: { buffer: { length: 80 } } },
                { name: "height", type: "uint128" }
              ]
            }
          },
          { name: "tx", type: { buffer: { length: 1024 } } },
          {
            name: "proof",
            type: {
              tuple: [
                {
                  name: "hashes",
                  type: { list: { type: { buffer: { length: 32 } }, length: 20 } }
                },
                { name: "tree-depth", type: "uint128" },
                { name: "tx-index", type: "uint128" }
              ]
            }
          }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      }
    },
    maps: {},
    variables: {
      BUFF_TO_BYTE: {
        name: "BUFF_TO_BYTE",
        type: {
          list: {
            type: {
              buffer: {
                length: 1
              }
            },
            length: 256
          }
        },
        access: "constant"
      },
      ERR_BAD_HEADER: {
        name: "ERR-BAD-HEADER",
        type: "uint128",
        access: "constant"
      },
      ERR_INVALID_PARENT: {
        name: "ERR-INVALID-PARENT",
        type: "uint128",
        access: "constant"
      },
      ERR_OUT_OF_BOUNDS: {
        name: "ERR-OUT-OF-BOUNDS",
        type: "uint128",
        access: "constant"
      },
      ERR_PROOF_TOO_SHORT: {
        name: "ERR-PROOF-TOO-SHORT",
        type: "uint128",
        access: "constant"
      },
      ERR_TOO_MANY_TXINS: {
        name: "ERR-TOO-MANY-TXINS",
        type: "uint128",
        access: "constant"
      },
      ERR_TOO_MANY_TXOUTS: {
        name: "ERR-TOO-MANY-TXOUTS",
        type: "uint128",
        access: "constant"
      },
      ERR_VARSLICE_TOO_LONG: {
        name: "ERR-VARSLICE-TOO-LONG",
        type: "uint128",
        access: "constant"
      },
      lIST_128: {
        name: "LIST_128",
        type: {
          list: {
            type: "bool",
            length: 128
          }
        },
        access: "constant"
      },
      lIST_16: {
        name: "LIST_16",
        type: {
          list: {
            type: "bool",
            length: 16
          }
        },
        access: "constant"
      },
      lIST_256: {
        name: "LIST_256",
        type: {
          list: {
            type: "bool",
            length: 256
          }
        },
        access: "constant"
      },
      lIST_32: {
        name: "LIST_32",
        type: {
          list: {
            type: "bool",
            length: 32
          }
        },
        access: "constant"
      },
      lIST_512: {
        name: "LIST_512",
        type: {
          list: {
            type: "bool",
            length: 512
          }
        },
        access: "constant"
      },
      lIST_64: {
        name: "LIST_64",
        type: {
          list: {
            type: "bool",
            length: 64
          }
        },
        access: "constant"
      }
    },
    constants: {
      BUFF_TO_BYTE: [
        Uint8Array.from([0]),
        Uint8Array.from([1]),
        Uint8Array.from([2]),
        Uint8Array.from([3]),
        Uint8Array.from([4]),
        Uint8Array.from([5]),
        Uint8Array.from([6]),
        Uint8Array.from([7]),
        Uint8Array.from([8]),
        Uint8Array.from([9]),
        Uint8Array.from([10]),
        Uint8Array.from([11]),
        Uint8Array.from([12]),
        Uint8Array.from([13]),
        Uint8Array.from([14]),
        Uint8Array.from([15]),
        Uint8Array.from([16]),
        Uint8Array.from([17]),
        Uint8Array.from([18]),
        Uint8Array.from([19]),
        Uint8Array.from([20]),
        Uint8Array.from([21]),
        Uint8Array.from([22]),
        Uint8Array.from([23]),
        Uint8Array.from([24]),
        Uint8Array.from([25]),
        Uint8Array.from([26]),
        Uint8Array.from([27]),
        Uint8Array.from([28]),
        Uint8Array.from([29]),
        Uint8Array.from([30]),
        Uint8Array.from([31]),
        Uint8Array.from([32]),
        Uint8Array.from([33]),
        Uint8Array.from([34]),
        Uint8Array.from([35]),
        Uint8Array.from([36]),
        Uint8Array.from([37]),
        Uint8Array.from([38]),
        Uint8Array.from([39]),
        Uint8Array.from([40]),
        Uint8Array.from([41]),
        Uint8Array.from([42]),
        Uint8Array.from([43]),
        Uint8Array.from([44]),
        Uint8Array.from([45]),
        Uint8Array.from([46]),
        Uint8Array.from([47]),
        Uint8Array.from([48]),
        Uint8Array.from([49]),
        Uint8Array.from([50]),
        Uint8Array.from([51]),
        Uint8Array.from([52]),
        Uint8Array.from([53]),
        Uint8Array.from([54]),
        Uint8Array.from([55]),
        Uint8Array.from([56]),
        Uint8Array.from([57]),
        Uint8Array.from([58]),
        Uint8Array.from([59]),
        Uint8Array.from([60]),
        Uint8Array.from([61]),
        Uint8Array.from([62]),
        Uint8Array.from([63]),
        Uint8Array.from([64]),
        Uint8Array.from([65]),
        Uint8Array.from([66]),
        Uint8Array.from([67]),
        Uint8Array.from([68]),
        Uint8Array.from([69]),
        Uint8Array.from([70]),
        Uint8Array.from([71]),
        Uint8Array.from([72]),
        Uint8Array.from([73]),
        Uint8Array.from([74]),
        Uint8Array.from([75]),
        Uint8Array.from([76]),
        Uint8Array.from([77]),
        Uint8Array.from([78]),
        Uint8Array.from([79]),
        Uint8Array.from([80]),
        Uint8Array.from([81]),
        Uint8Array.from([82]),
        Uint8Array.from([83]),
        Uint8Array.from([84]),
        Uint8Array.from([85]),
        Uint8Array.from([86]),
        Uint8Array.from([87]),
        Uint8Array.from([88]),
        Uint8Array.from([89]),
        Uint8Array.from([90]),
        Uint8Array.from([91]),
        Uint8Array.from([92]),
        Uint8Array.from([93]),
        Uint8Array.from([94]),
        Uint8Array.from([95]),
        Uint8Array.from([96]),
        Uint8Array.from([97]),
        Uint8Array.from([98]),
        Uint8Array.from([99]),
        Uint8Array.from([100]),
        Uint8Array.from([101]),
        Uint8Array.from([102]),
        Uint8Array.from([103]),
        Uint8Array.from([104]),
        Uint8Array.from([105]),
        Uint8Array.from([106]),
        Uint8Array.from([107]),
        Uint8Array.from([108]),
        Uint8Array.from([109]),
        Uint8Array.from([110]),
        Uint8Array.from([111]),
        Uint8Array.from([112]),
        Uint8Array.from([113]),
        Uint8Array.from([114]),
        Uint8Array.from([115]),
        Uint8Array.from([116]),
        Uint8Array.from([117]),
        Uint8Array.from([118]),
        Uint8Array.from([119]),
        Uint8Array.from([120]),
        Uint8Array.from([121]),
        Uint8Array.from([122]),
        Uint8Array.from([123]),
        Uint8Array.from([124]),
        Uint8Array.from([125]),
        Uint8Array.from([126]),
        Uint8Array.from([127]),
        Uint8Array.from([128]),
        Uint8Array.from([129]),
        Uint8Array.from([130]),
        Uint8Array.from([131]),
        Uint8Array.from([132]),
        Uint8Array.from([133]),
        Uint8Array.from([134]),
        Uint8Array.from([135]),
        Uint8Array.from([136]),
        Uint8Array.from([137]),
        Uint8Array.from([138]),
        Uint8Array.from([139]),
        Uint8Array.from([140]),
        Uint8Array.from([141]),
        Uint8Array.from([142]),
        Uint8Array.from([143]),
        Uint8Array.from([144]),
        Uint8Array.from([145]),
        Uint8Array.from([146]),
        Uint8Array.from([147]),
        Uint8Array.from([148]),
        Uint8Array.from([149]),
        Uint8Array.from([150]),
        Uint8Array.from([151]),
        Uint8Array.from([152]),
        Uint8Array.from([153]),
        Uint8Array.from([154]),
        Uint8Array.from([155]),
        Uint8Array.from([156]),
        Uint8Array.from([157]),
        Uint8Array.from([158]),
        Uint8Array.from([159]),
        Uint8Array.from([160]),
        Uint8Array.from([161]),
        Uint8Array.from([162]),
        Uint8Array.from([163]),
        Uint8Array.from([164]),
        Uint8Array.from([165]),
        Uint8Array.from([166]),
        Uint8Array.from([167]),
        Uint8Array.from([168]),
        Uint8Array.from([169]),
        Uint8Array.from([170]),
        Uint8Array.from([171]),
        Uint8Array.from([172]),
        Uint8Array.from([173]),
        Uint8Array.from([174]),
        Uint8Array.from([175]),
        Uint8Array.from([176]),
        Uint8Array.from([177]),
        Uint8Array.from([178]),
        Uint8Array.from([179]),
        Uint8Array.from([180]),
        Uint8Array.from([181]),
        Uint8Array.from([182]),
        Uint8Array.from([183]),
        Uint8Array.from([184]),
        Uint8Array.from([185]),
        Uint8Array.from([186]),
        Uint8Array.from([187]),
        Uint8Array.from([188]),
        Uint8Array.from([189]),
        Uint8Array.from([190]),
        Uint8Array.from([191]),
        Uint8Array.from([192]),
        Uint8Array.from([193]),
        Uint8Array.from([194]),
        Uint8Array.from([195]),
        Uint8Array.from([196]),
        Uint8Array.from([197]),
        Uint8Array.from([198]),
        Uint8Array.from([199]),
        Uint8Array.from([200]),
        Uint8Array.from([201]),
        Uint8Array.from([202]),
        Uint8Array.from([203]),
        Uint8Array.from([204]),
        Uint8Array.from([205]),
        Uint8Array.from([206]),
        Uint8Array.from([207]),
        Uint8Array.from([208]),
        Uint8Array.from([209]),
        Uint8Array.from([210]),
        Uint8Array.from([211]),
        Uint8Array.from([212]),
        Uint8Array.from([213]),
        Uint8Array.from([214]),
        Uint8Array.from([215]),
        Uint8Array.from([216]),
        Uint8Array.from([217]),
        Uint8Array.from([218]),
        Uint8Array.from([219]),
        Uint8Array.from([220]),
        Uint8Array.from([221]),
        Uint8Array.from([222]),
        Uint8Array.from([223]),
        Uint8Array.from([224]),
        Uint8Array.from([225]),
        Uint8Array.from([226]),
        Uint8Array.from([227]),
        Uint8Array.from([228]),
        Uint8Array.from([229]),
        Uint8Array.from([230]),
        Uint8Array.from([231]),
        Uint8Array.from([232]),
        Uint8Array.from([233]),
        Uint8Array.from([234]),
        Uint8Array.from([235]),
        Uint8Array.from([236]),
        Uint8Array.from([237]),
        Uint8Array.from([238]),
        Uint8Array.from([239]),
        Uint8Array.from([240]),
        Uint8Array.from([241]),
        Uint8Array.from([242]),
        Uint8Array.from([243]),
        Uint8Array.from([244]),
        Uint8Array.from([245]),
        Uint8Array.from([246]),
        Uint8Array.from([247]),
        Uint8Array.from([248]),
        Uint8Array.from([249]),
        Uint8Array.from([250]),
        Uint8Array.from([251]),
        Uint8Array.from([252]),
        Uint8Array.from([253]),
        Uint8Array.from([254]),
        Uint8Array.from([255])
      ],
      eRRBADHEADER: 5n,
      eRRINVALIDPARENT: 7n,
      eRROUTOFBOUNDS: 1n,
      eRRPROOFTOOSHORT: 6n,
      eRRTOOMANYTXINS: 2n,
      eRRTOOMANYTXOUTS: 3n,
      eRRVARSLICETOOLONG: 4n,
      lIST_128: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      lIST_16: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      lIST_256: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      lIST_32: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      lIST_512: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      lIST_64: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ]
    },
    non_fungible_tokens: [],
    fungible_tokens: [],
    epoch: "Epoch21",
    clarity_version: "Clarity2",
    contractName: "clarity-bitcoin"
  },
  ftTrait: {
    functions: {},
    maps: {},
    variables: {},
    constants: {},
    non_fungible_tokens: [],
    fungible_tokens: [],
    epoch: "Epoch20",
    clarity_version: "Clarity1",
    contractName: "ft-trait"
  },
  magic: {
    functions: {
      transfer: {
        name: "transfer",
        access: "private",
        args: [
          { name: "amount", type: "uint128" },
          { name: "sender", type: "principal" },
          { name: "recipient", type: "principal" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      updateUserInboundVolume: {
        name: "update-user-inbound-volume",
        access: "private",
        args: [
          { name: "user", type: "principal" },
          { name: "amount", type: "uint128" }
        ],
        outputs: { type: "bool" }
      },
      updateUserOutboundVolume: {
        name: "update-user-outbound-volume",
        access: "private",
        args: [
          { name: "user", type: "principal" },
          { name: "amount", type: "uint128" }
        ],
        outputs: { type: "bool" }
      },
      addFunds: {
        name: "add-funds",
        access: "public",
        args: [{ name: "amount", type: "uint128" }],
        outputs: { type: { response: { ok: "uint128", error: "uint128" } } }
      },
      escrowSwap: {
        name: "escrow-swap",
        access: "public",
        args: [
          {
            name: "block",
            type: {
              tuple: [
                { name: "header", type: { buffer: { length: 80 } } },
                { name: "height", type: "uint128" }
              ]
            }
          },
          { name: "prev-blocks", type: { list: { type: { buffer: { length: 80 } }, length: 10 } } },
          { name: "tx", type: { buffer: { length: 1024 } } },
          {
            name: "proof",
            type: {
              tuple: [
                {
                  name: "hashes",
                  type: { list: { type: { buffer: { length: 32 } }, length: 20 } }
                },
                { name: "tree-depth", type: "uint128" },
                { name: "tx-index", type: "uint128" }
              ]
            }
          },
          { name: "output-index", type: "uint128" },
          { name: "sender", type: { buffer: { length: 33 } } },
          { name: "recipient", type: { buffer: { length: 33 } } },
          { name: "expiration-buff", type: { buffer: { length: 4 } } },
          { name: "hash", type: { buffer: { length: 32 } } },
          { name: "swapper", type: "principal" },
          { name: "supplier-id", type: "uint128" },
          { name: "max-base-fee", type: "int128" },
          { name: "max-fee-rate", type: "int128" }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "csv", type: "uint128" },
                  { name: "output-index", type: "uint128" },
                  { name: "redeem-script", type: { buffer: { length: 148 } } },
                  { name: "sats", type: "uint128" },
                  { name: "sender-public-key", type: { buffer: { length: 33 } } }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      finalizeOutboundSwap: {
        name: "finalize-outbound-swap",
        access: "public",
        args: [
          {
            name: "block",
            type: {
              tuple: [
                { name: "header", type: { buffer: { length: 80 } } },
                { name: "height", type: "uint128" }
              ]
            }
          },
          { name: "prev-blocks", type: { list: { type: { buffer: { length: 80 } }, length: 10 } } },
          { name: "tx", type: { buffer: { length: 1024 } } },
          {
            name: "proof",
            type: {
              tuple: [
                {
                  name: "hashes",
                  type: { list: { type: { buffer: { length: 32 } }, length: 20 } }
                },
                { name: "tree-depth", type: "uint128" },
                { name: "tx-index", type: "uint128" }
              ]
            }
          },
          { name: "output-index", type: "uint128" },
          { name: "swap-id", type: "uint128" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      finalizeSwap: {
        name: "finalize-swap",
        access: "public",
        args: [
          { name: "txid", type: { buffer: { length: 32 } } },
          { name: "preimage", type: { buffer: { length: 128 } } }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "expiration", type: "uint128" },
                  { name: "hash", type: { buffer: { length: 32 } } },
                  { name: "supplier", type: "uint128" },
                  { name: "swapper", type: "principal" },
                  { name: "xbtc", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      initiateOutboundSwap: {
        name: "initiate-outbound-swap",
        access: "public",
        args: [
          { name: "xbtc", type: "uint128" },
          { name: "output", type: { buffer: { length: 128 } } },
          { name: "supplier-id", type: "uint128" },
          { name: "min-to-receive", type: "uint128" }
        ],
        outputs: { type: { response: { ok: "uint128", error: "uint128" } } }
      },
      registerSupplier: {
        name: "register-supplier",
        access: "public",
        args: [
          { name: "public-key", type: { buffer: { length: 33 } } },
          { name: "inbound-fee", type: { optional: "int128" } },
          { name: "outbound-fee", type: { optional: "int128" } },
          { name: "outbound-base-fee", type: "int128" },
          { name: "inbound-base-fee", type: "int128" },
          { name: "funds", type: "uint128" }
        ],
        outputs: { type: { response: { ok: "uint128", error: "uint128" } } }
      },
      removeFunds: {
        name: "remove-funds",
        access: "public",
        args: [{ name: "amount", type: "uint128" }],
        outputs: { type: { response: { ok: "uint128", error: "uint128" } } }
      },
      revokeExpiredInbound: {
        name: "revoke-expired-inbound",
        access: "public",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "expiration", type: "uint128" },
                  { name: "hash", type: { buffer: { length: 32 } } },
                  { name: "supplier", type: "uint128" },
                  { name: "swapper", type: "principal" },
                  { name: "xbtc", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      revokeExpiredOutbound: {
        name: "revoke-expired-outbound",
        access: "public",
        args: [{ name: "swap-id", type: "uint128" }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "created-at", type: "uint128" },
                  { name: "output", type: { buffer: { length: 128 } } },
                  { name: "sats", type: "uint128" },
                  { name: "supplier", type: "uint128" },
                  { name: "swapper", type: "principal" },
                  { name: "xbtc", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      updateSupplierFees: {
        name: "update-supplier-fees",
        access: "public",
        args: [
          { name: "inbound-fee", type: { optional: "int128" } },
          { name: "outbound-fee", type: { optional: "int128" } },
          { name: "outbound-base-fee", type: "int128" },
          { name: "inbound-base-fee", type: "int128" }
        ],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "controller", type: "principal" },
                  { name: "inbound-base-fee", type: "int128" },
                  { name: "inbound-fee", type: { optional: "int128" } },
                  { name: "outbound-base-fee", type: "int128" },
                  { name: "outbound-fee", type: { optional: "int128" } },
                  { name: "public-key", type: { buffer: { length: 33 } } }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      updateSupplierPublicKey: {
        name: "update-supplier-public-key",
        access: "public",
        args: [{ name: "public-key", type: { buffer: { length: 33 } } }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "controller", type: "principal" },
                  { name: "inbound-base-fee", type: "int128" },
                  { name: "inbound-fee", type: { optional: "int128" } },
                  { name: "outbound-base-fee", type: "int128" },
                  { name: "outbound-fee", type: { optional: "int128" } },
                  { name: "public-key", type: { buffer: { length: 33 } } }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      bytesLen: {
        name: "bytes-len",
        access: "read_only",
        args: [{ name: "bytes", type: { buffer: { length: 4 } } }],
        outputs: { type: { buffer: { length: 1 } } }
      },
      generateHtlcScript: {
        name: "generate-htlc-script",
        access: "read_only",
        args: [
          { name: "sender", type: { buffer: { length: 33 } } },
          { name: "recipient", type: { buffer: { length: 33 } } },
          { name: "expiration", type: { buffer: { length: 4 } } },
          { name: "hash", type: { buffer: { length: 32 } } },
          { name: "metadata", type: { buffer: { length: 32 } } }
        ],
        outputs: { type: { buffer: { length: 148 } } }
      },
      generateWshOutput: {
        name: "generate-wsh-output",
        access: "read_only",
        args: [{ name: "script", type: { buffer: { length: 148 } } }],
        outputs: { type: { buffer: { length: 34 } } }
      },
      getAmountWithFeeRate: {
        name: "get-amount-with-fee-rate",
        access: "read_only",
        args: [
          { name: "amount", type: "uint128" },
          { name: "fee-rate", type: "int128" }
        ],
        outputs: { type: "int128" }
      },
      getCompletedOutboundSwapByTxid: {
        name: "get-completed-outbound-swap-by-txid",
        access: "read_only",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: { type: { optional: "uint128" } }
      },
      getCompletedOutboundSwapTxid: {
        name: "get-completed-outbound-swap-txid",
        access: "read_only",
        args: [{ name: "id", type: "uint128" }],
        outputs: { type: { optional: { buffer: { length: 32 } } } }
      },
      getEscrow: {
        name: "get-escrow",
        access: "read_only",
        args: [{ name: "id", type: "uint128" }],
        outputs: { type: { optional: "uint128" } }
      },
      getFullInbound: {
        name: "get-full-inbound",
        access: "read_only",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "csv", type: "uint128" },
                  { name: "expiration", type: "uint128" },
                  { name: "hash", type: { buffer: { length: 32 } } },
                  { name: "output-index", type: "uint128" },
                  { name: "redeem-script", type: { buffer: { length: 148 } } },
                  { name: "sats", type: "uint128" },
                  { name: "sender-public-key", type: { buffer: { length: 33 } } },
                  { name: "supplier", type: "uint128" },
                  { name: "swapper", type: "principal" },
                  { name: "xbtc", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      getFullSupplier: {
        name: "get-full-supplier",
        access: "read_only",
        args: [{ name: "id", type: "uint128" }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "controller", type: "principal" },
                  { name: "escrow", type: "uint128" },
                  { name: "funds", type: "uint128" },
                  { name: "inbound-base-fee", type: "int128" },
                  { name: "inbound-fee", type: { optional: "int128" } },
                  { name: "outbound-base-fee", type: "int128" },
                  { name: "outbound-fee", type: { optional: "int128" } },
                  { name: "public-key", type: { buffer: { length: 33 } } }
                ]
              },
              error: "uint128"
            }
          }
        }
      },
      getFunds: {
        name: "get-funds",
        access: "read_only",
        args: [{ name: "id", type: "uint128" }],
        outputs: { type: "uint128" }
      },
      getInboundMeta: {
        name: "get-inbound-meta",
        access: "read_only",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: {
          type: {
            optional: {
              tuple: [
                { name: "csv", type: "uint128" },
                { name: "output-index", type: "uint128" },
                { name: "redeem-script", type: { buffer: { length: 148 } } },
                { name: "sats", type: "uint128" },
                { name: "sender-public-key", type: { buffer: { length: 33 } } }
              ]
            }
          }
        }
      },
      getInboundSwap: {
        name: "get-inbound-swap",
        access: "read_only",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: {
          type: {
            optional: {
              tuple: [
                { name: "expiration", type: "uint128" },
                { name: "hash", type: { buffer: { length: 32 } } },
                { name: "supplier", type: "uint128" },
                { name: "swapper", type: "principal" },
                { name: "xbtc", type: "uint128" }
              ]
            }
          }
        }
      },
      getNextOutboundId: {
        name: "get-next-outbound-id",
        access: "read_only",
        args: [],
        outputs: { type: "uint128" }
      },
      getNextSupplierId: {
        name: "get-next-supplier-id",
        access: "read_only",
        args: [],
        outputs: { type: "uint128" }
      },
      getOutboundSwap: {
        name: "get-outbound-swap",
        access: "read_only",
        args: [{ name: "id", type: "uint128" }],
        outputs: {
          type: {
            optional: {
              tuple: [
                { name: "created-at", type: "uint128" },
                { name: "output", type: { buffer: { length: 128 } } },
                { name: "sats", type: "uint128" },
                { name: "supplier", type: "uint128" },
                { name: "swapper", type: "principal" },
                { name: "xbtc", type: "uint128" }
              ]
            }
          }
        }
      },
      getPreimage: {
        name: "get-preimage",
        access: "read_only",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: { type: { optional: { buffer: { length: 128 } } } }
      },
      getSupplier: {
        name: "get-supplier",
        access: "read_only",
        args: [{ name: "id", type: "uint128" }],
        outputs: {
          type: {
            optional: {
              tuple: [
                { name: "controller", type: "principal" },
                { name: "inbound-base-fee", type: "int128" },
                { name: "inbound-fee", type: { optional: "int128" } },
                { name: "outbound-base-fee", type: "int128" },
                { name: "outbound-fee", type: { optional: "int128" } },
                { name: "public-key", type: { buffer: { length: 33 } } }
              ]
            }
          }
        }
      },
      getSupplierIdByController: {
        name: "get-supplier-id-by-controller",
        access: "read_only",
        args: [{ name: "controller", type: "principal" }],
        outputs: { type: { optional: "uint128" } }
      },
      getSupplierIdByPublicKey: {
        name: "get-supplier-id-by-public-key",
        access: "read_only",
        args: [{ name: "public-key", type: { buffer: { length: 33 } } }],
        outputs: { type: { optional: "uint128" } }
      },
      getSwapAmount: {
        name: "get-swap-amount",
        access: "read_only",
        args: [
          { name: "amount", type: "uint128" },
          { name: "fee-rate", type: "int128" },
          { name: "base-fee", type: "int128" }
        ],
        outputs: { type: { response: { ok: "uint128", error: "uint128" } } }
      },
      getTotalInboundVolume: {
        name: "get-total-inbound-volume",
        access: "read_only",
        args: [],
        outputs: { type: "uint128" }
      },
      getTotalOutboundVolume: {
        name: "get-total-outbound-volume",
        access: "read_only",
        args: [],
        outputs: { type: "uint128" }
      },
      getTotalVolume: {
        name: "get-total-volume",
        access: "read_only",
        args: [],
        outputs: { type: "uint128" }
      },
      getUserInboundVolume: {
        name: "get-user-inbound-volume",
        access: "read_only",
        args: [{ name: "user", type: "principal" }],
        outputs: { type: "uint128" }
      },
      getUserOutboundVolume: {
        name: "get-user-outbound-volume",
        access: "read_only",
        args: [{ name: "user", type: "principal" }],
        outputs: { type: "uint128" }
      },
      getUserTotalVolume: {
        name: "get-user-total-volume",
        access: "read_only",
        args: [{ name: "user", type: "principal" }],
        outputs: { type: "uint128" }
      },
      hashMetadata: {
        name: "hash-metadata",
        access: "read_only",
        args: [
          { name: "swapper", type: "principal" },
          { name: "base-fee", type: "int128" },
          { name: "fee-rate", type: "int128" }
        ],
        outputs: { type: { buffer: { length: 32 } } }
      },
      readVarint: {
        name: "read-varint",
        access: "read_only",
        args: [{ name: "num", type: { buffer: { length: 4 } } }],
        outputs: { type: { response: { ok: "uint128", error: "uint128" } } }
      },
      serializeMetadata: {
        name: "serialize-metadata",
        access: "read_only",
        args: [
          { name: "swapper", type: "principal" },
          { name: "base-fee", type: "int128" },
          { name: "fee-rate", type: "int128" }
        ],
        outputs: { type: { buffer: { length: 216 } } }
      },
      validateExpiration: {
        name: "validate-expiration",
        access: "read_only",
        args: [
          { name: "expiration", type: "uint128" },
          { name: "mined-height", type: "uint128" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      validateFee: {
        name: "validate-fee",
        access: "read_only",
        args: [{ name: "fee-opt", type: { optional: "int128" } }],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      validateOutboundRevocable: {
        name: "validate-outbound-revocable",
        access: "read_only",
        args: [{ name: "swap-id", type: "uint128" }],
        outputs: {
          type: {
            response: {
              ok: {
                tuple: [
                  { name: "created-at", type: "uint128" },
                  { name: "output", type: { buffer: { length: 128 } } },
                  { name: "sats", type: "uint128" },
                  { name: "supplier", type: "uint128" },
                  { name: "swapper", type: "principal" },
                  { name: "xbtc", type: "uint128" }
                ]
              },
              error: "uint128"
            }
          }
        }
      }
    },
    maps: {
      completedOutboundSwapTxids: {
        name: "completed-outbound-swap-txids",
        key: { buffer: { length: 32 } },
        value: "uint128"
      },
      completedOutboundSwaps: {
        name: "completed-outbound-swaps",
        key: "uint128",
        value: { buffer: { length: 32 } }
      },
      inboundMeta: {
        name: "inbound-meta",
        key: { buffer: { length: 32 } },
        value: {
          tuple: [
            { name: "csv", type: "uint128" },
            { name: "output-index", type: "uint128" },
            { name: "redeem-script", type: { buffer: { length: 148 } } },
            { name: "sats", type: "uint128" },
            { name: "sender-public-key", type: { buffer: { length: 33 } } }
          ]
        }
      },
      inboundPreimages: {
        name: "inbound-preimages",
        key: { buffer: { length: 32 } },
        value: { buffer: { length: 128 } }
      },
      inboundSwaps: {
        name: "inbound-swaps",
        key: { buffer: { length: 32 } },
        value: {
          tuple: [
            { name: "expiration", type: "uint128" },
            { name: "hash", type: { buffer: { length: 32 } } },
            { name: "supplier", type: "uint128" },
            { name: "swapper", type: "principal" },
            { name: "xbtc", type: "uint128" }
          ]
        }
      },
      outboundSwaps: {
        name: "outbound-swaps",
        key: "uint128",
        value: {
          tuple: [
            { name: "created-at", type: "uint128" },
            { name: "output", type: { buffer: { length: 128 } } },
            { name: "sats", type: "uint128" },
            { name: "supplier", type: "uint128" },
            { name: "swapper", type: "principal" },
            { name: "xbtc", type: "uint128" }
          ]
        }
      },
      supplierByController: {
        name: "supplier-by-controller",
        key: "principal",
        value: "uint128"
      },
      supplierById: {
        name: "supplier-by-id",
        key: "uint128",
        value: {
          tuple: [
            { name: "controller", type: "principal" },
            { name: "inbound-base-fee", type: "int128" },
            { name: "inbound-fee", type: { optional: "int128" } },
            { name: "outbound-base-fee", type: "int128" },
            { name: "outbound-fee", type: { optional: "int128" } },
            { name: "public-key", type: { buffer: { length: 33 } } }
          ]
        }
      },
      supplierByPublicKey: {
        name: "supplier-by-public-key",
        key: { buffer: { length: 33 } },
        value: "uint128"
      },
      supplierEscrow: { name: "supplier-escrow", key: "uint128", value: "uint128" },
      supplierFunds: { name: "supplier-funds", key: "uint128", value: "uint128" },
      swapperById: { name: "swapper-by-id", key: "uint128", value: "principal" },
      swapperByPrincipal: {
        name: "swapper-by-principal",
        key: "principal",
        value: "uint128"
      },
      userInboundVolumeMap: {
        name: "user-inbound-volume-map",
        key: "principal",
        value: "uint128"
      },
      userOutboundVolumeMap: {
        name: "user-outbound-volume-map",
        key: "principal",
        value: "uint128"
      }
    },
    variables: {
      BUFF_TO_BYTE: {
        name: "BUFF_TO_BYTE",
        type: {
          list: {
            type: {
              buffer: {
                length: 1
              }
            },
            length: 5
          }
        },
        access: "constant"
      },
      ERR_ADD_FUNDS: {
        name: "ERR_ADD_FUNDS",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_ALREADY_FINALIZED: {
        name: "ERR_ALREADY_FINALIZED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_ESCROW_EXPIRED: {
        name: "ERR_ESCROW_EXPIRED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_FEE_INVALID: {
        name: "ERR_FEE_INVALID",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INCONSISTENT_FEES: {
        name: "ERR_INCONSISTENT_FEES",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INSUFFICIENT_AMOUNT: {
        name: "ERR_INSUFFICIENT_AMOUNT",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INSUFFICIENT_FUNDS: {
        name: "ERR_INSUFFICIENT_FUNDS",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_BTC_ADDR: {
        name: "ERR_INVALID_BTC_ADDR",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_ESCROW: {
        name: "ERR_INVALID_ESCROW",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_EXPIRATION: {
        name: "ERR_INVALID_EXPIRATION",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_HASH: {
        name: "ERR_INVALID_HASH",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_OUTPUT: {
        name: "ERR_INVALID_OUTPUT",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_PREIMAGE: {
        name: "ERR_INVALID_PREIMAGE",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_SUPPLIER: {
        name: "ERR_INVALID_SUPPLIER",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_INVALID_TX: {
        name: "ERR_INVALID_TX",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_READ_UINT: {
        name: "ERR_READ_UINT",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_REVOKE_INBOUND_IS_FINALIZED: {
        name: "ERR_REVOKE_INBOUND_IS_FINALIZED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_REVOKE_INBOUND_NOT_EXPIRED: {
        name: "ERR_REVOKE_INBOUND_NOT_EXPIRED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_REVOKE_OUTBOUND_IS_FINALIZED: {
        name: "ERR_REVOKE_OUTBOUND_IS_FINALIZED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_REVOKE_OUTBOUND_NOT_EXPIRED: {
        name: "ERR_REVOKE_OUTBOUND_NOT_EXPIRED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_SUPPLIER_EXISTS: {
        name: "ERR_SUPPLIER_EXISTS",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_SUPPLIER_NOT_FOUND: {
        name: "ERR_SUPPLIER_NOT_FOUND",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_SWAPPER_EXISTS: {
        name: "ERR_SWAPPER_EXISTS",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_SWAPPER_NOT_FOUND: {
        name: "ERR_SWAPPER_NOT_FOUND",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_SWAP_NOT_FOUND: {
        name: "ERR_SWAP_NOT_FOUND",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_TRANSFER: {
        name: "ERR_TRANSFER",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_TXID_USED: {
        name: "ERR_TXID_USED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_TX_NOT_MINED: {
        name: "ERR_TX_NOT_MINED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ERR_UNAUTHORIZED: {
        name: "ERR_UNAUTHORIZED",
        type: {
          response: {
            ok: "none",
            error: "uint128"
          }
        },
        access: "constant"
      },
      ESCROW_EXPIRATION: {
        name: "ESCROW_EXPIRATION",
        type: "uint128",
        access: "constant"
      },
      MAX_HTLC_EXPIRATION: {
        name: "MAX_HTLC_EXPIRATION",
        type: "uint128",
        access: "constant"
      },
      MIN_EXPIRATION: {
        name: "MIN_EXPIRATION",
        type: "uint128",
        access: "constant"
      },
      OUTBOUND_EXPIRATION: {
        name: "OUTBOUND_EXPIRATION",
        type: "uint128",
        access: "constant"
      },
      p2PKH_VERSION: {
        name: "P2PKH_VERSION",
        type: {
          buffer: {
            length: 1
          }
        },
        access: "constant"
      },
      p2SH_VERSION: {
        name: "P2SH_VERSION",
        type: {
          buffer: {
            length: 1
          }
        },
        access: "constant"
      },
      REVOKED_INBOUND_PREIMAGE: {
        name: "REVOKED_INBOUND_PREIMAGE",
        type: {
          buffer: {
            length: 1
          }
        },
        access: "constant"
      },
      REVOKED_OUTBOUND_TXID: {
        name: "REVOKED_OUTBOUND_TXID",
        type: {
          buffer: {
            length: 1
          }
        },
        access: "constant"
      },
      nextOutboundId: {
        name: "next-outbound-id",
        type: "uint128",
        access: "variable"
      },
      nextSupplierId: {
        name: "next-supplier-id",
        type: "uint128",
        access: "variable"
      },
      nextSwapperId: {
        name: "next-swapper-id",
        type: "uint128",
        access: "variable"
      },
      totalInboundVolumeVar: {
        name: "total-inbound-volume-var",
        type: "uint128",
        access: "variable"
      },
      totalOutboundVolumeVar: {
        name: "total-outbound-volume-var",
        type: "uint128",
        access: "variable"
      }
    },
    constants: {
      BUFF_TO_BYTE: [
        Uint8Array.from([0]),
        Uint8Array.from([1]),
        Uint8Array.from([2]),
        Uint8Array.from([3]),
        Uint8Array.from([4])
      ],
      ERR_ADD_FUNDS: {
        isOk: false,
        value: 4n
      },
      ERR_ALREADY_FINALIZED: {
        isOk: false,
        value: 17n
      },
      ERR_ESCROW_EXPIRED: {
        isOk: false,
        value: 20n
      },
      ERR_FEE_INVALID: {
        isOk: false,
        value: 8n
      },
      ERR_INCONSISTENT_FEES: {
        isOk: false,
        value: 27n
      },
      ERR_INSUFFICIENT_AMOUNT: {
        isOk: false,
        value: 24n
      },
      ERR_INSUFFICIENT_FUNDS: {
        isOk: false,
        value: 14n
      },
      ERR_INVALID_BTC_ADDR: {
        isOk: false,
        value: 22n
      },
      ERR_INVALID_ESCROW: {
        isOk: false,
        value: 18n
      },
      ERR_INVALID_EXPIRATION: {
        isOk: false,
        value: 15n
      },
      ERR_INVALID_HASH: {
        isOk: false,
        value: 12n
      },
      ERR_INVALID_OUTPUT: {
        isOk: false,
        value: 11n
      },
      ERR_INVALID_PREIMAGE: {
        isOk: false,
        value: 19n
      },
      ERR_INVALID_SUPPLIER: {
        isOk: false,
        value: 13n
      },
      ERR_INVALID_TX: {
        isOk: false,
        value: 10n
      },
      ERR_READ_UINT: {
        isOk: false,
        value: 100n
      },
      ERR_REVOKE_INBOUND_IS_FINALIZED: {
        isOk: false,
        value: 29n
      },
      ERR_REVOKE_INBOUND_NOT_EXPIRED: {
        isOk: false,
        value: 28n
      },
      ERR_REVOKE_OUTBOUND_IS_FINALIZED: {
        isOk: false,
        value: 26n
      },
      ERR_REVOKE_OUTBOUND_NOT_EXPIRED: {
        isOk: false,
        value: 25n
      },
      ERR_SUPPLIER_EXISTS: {
        isOk: false,
        value: 2n
      },
      ERR_SUPPLIER_NOT_FOUND: {
        isOk: false,
        value: 6n
      },
      ERR_SWAPPER_EXISTS: {
        isOk: false,
        value: 9n
      },
      ERR_SWAPPER_NOT_FOUND: {
        isOk: false,
        value: 7n
      },
      ERR_SWAP_NOT_FOUND: {
        isOk: false,
        value: 23n
      },
      ERR_TRANSFER: {
        isOk: false,
        value: 5n
      },
      ERR_TXID_USED: {
        isOk: false,
        value: 16n
      },
      ERR_TX_NOT_MINED: {
        isOk: false,
        value: 21n
      },
      ERR_UNAUTHORIZED: {
        isOk: false,
        value: 3n
      },
      ESCROW_EXPIRATION: 200n,
      MAX_HTLC_EXPIRATION: 550n,
      MIN_EXPIRATION: 250n,
      OUTBOUND_EXPIRATION: 200n,
      p2PKH_VERSION: Uint8Array.from([0]),
      p2SH_VERSION: Uint8Array.from([5]),
      REVOKED_INBOUND_PREIMAGE: Uint8Array.from([0]),
      REVOKED_OUTBOUND_TXID: Uint8Array.from([0]),
      nextOutboundId: 0n,
      nextSupplierId: 0n,
      nextSwapperId: 0n,
      totalInboundVolumeVar: 0n,
      totalOutboundVolumeVar: 0n
    },
    non_fungible_tokens: [],
    fungible_tokens: [],
    epoch: "Epoch21",
    clarity_version: "Clarity2",
    contractName: "magic"
  },
  restrictedTokenTrait: {
    functions: {},
    maps: {},
    variables: {},
    constants: {},
    non_fungible_tokens: [],
    fungible_tokens: [],
    epoch: "Epoch20",
    clarity_version: "Clarity1",
    contractName: "restricted-token-trait"
  },
  testUtils: {
    functions: {
      setBurnHeader: {
        name: "set-burn-header",
        access: "public",
        args: [
          { name: "height", type: "uint128" },
          { name: "header", type: { buffer: { length: 80 } } }
        ],
        outputs: { type: { response: { ok: "bool", error: "none" } } }
      },
      setMined: {
        name: "set-mined",
        access: "public",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: { type: { response: { ok: "bool", error: "none" } } }
      },
      setNotMined: {
        name: "set-not-mined",
        access: "public",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: { type: { response: { ok: "bool", error: "none" } } }
      },
      burnBlockHeader: {
        name: "burn-block-header",
        access: "read_only",
        args: [{ name: "height", type: "uint128" }],
        outputs: { type: { optional: { buffer: { length: 80 } } } }
      },
      wasMined: {
        name: "was-mined",
        access: "read_only",
        args: [{ name: "txid", type: { buffer: { length: 32 } } }],
        outputs: { type: { optional: "bool" } }
      }
    },
    maps: {
      burnBlockHeaders: {
        name: "burn-block-headers",
        key: "uint128",
        value: { buffer: { length: 80 } }
      },
      minedTxs: {
        name: "mined-txs",
        key: { buffer: { length: 32 } },
        value: "bool"
      }
    },
    variables: {},
    constants: {},
    non_fungible_tokens: [],
    fungible_tokens: [],
    epoch: "Epoch21",
    clarity_version: "Clarity2",
    contractName: "test-utils"
  },
  wrappedBitcoin: {
    functions: {
      addPrincipalToRole: {
        name: "add-principal-to-role",
        access: "public",
        args: [
          { name: "role-to-add", type: "uint128" },
          { name: "principal-to-add", type: "principal" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      burnTokens: {
        name: "burn-tokens",
        access: "public",
        args: [
          { name: "burn-amount", type: "uint128" },
          { name: "burn-from", type: "principal" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      initialize: {
        name: "initialize",
        access: "public",
        args: [
          { name: "name-to-set", type: { "string-ascii": { length: 32 } } },
          { name: "symbol-to-set", type: { "string-ascii": { length: 32 } } },
          { name: "decimals-to-set", type: "uint128" },
          { name: "initial-owner", type: "principal" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      mintTokens: {
        name: "mint-tokens",
        access: "public",
        args: [
          { name: "mint-amount", type: "uint128" },
          { name: "mint-to", type: "principal" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      removePrincipalFromRole: {
        name: "remove-principal-from-role",
        access: "public",
        args: [
          { name: "role-to-remove", type: "uint128" },
          { name: "principal-to-remove", type: "principal" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      revokeTokens: {
        name: "revoke-tokens",
        access: "public",
        args: [
          { name: "revoke-amount", type: "uint128" },
          { name: "revoke-from", type: "principal" },
          { name: "revoke-to", type: "principal" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      setTokenUri: {
        name: "set-token-uri",
        access: "public",
        args: [{ name: "updated-uri", type: { "string-utf8": { length: 256 } } }],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      transfer: {
        name: "transfer",
        access: "public",
        args: [
          { name: "amount", type: "uint128" },
          { name: "sender", type: "principal" },
          { name: "recipient", type: "principal" },
          { name: "memo", type: { optional: { buffer: { length: 34 } } } }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      updateBlacklisted: {
        name: "update-blacklisted",
        access: "public",
        args: [
          { name: "principal-to-update", type: "principal" },
          { name: "set-blacklisted", type: "bool" }
        ],
        outputs: { type: { response: { ok: "bool", error: "uint128" } } }
      },
      detectTransferRestriction: {
        name: "detect-transfer-restriction",
        access: "read_only",
        args: [
          { name: "amount", type: "uint128" },
          { name: "sender", type: "principal" },
          { name: "recipient", type: "principal" }
        ],
        outputs: { type: { response: { ok: "uint128", error: "uint128" } } }
      },
      getBalance: {
        name: "get-balance",
        access: "read_only",
        args: [{ name: "owner", type: "principal" }],
        outputs: { type: { response: { ok: "uint128", error: "none" } } }
      },
      getDecimals: {
        name: "get-decimals",
        access: "read_only",
        args: [],
        outputs: { type: { response: { ok: "uint128", error: "none" } } }
      },
      getName: {
        name: "get-name",
        access: "read_only",
        args: [],
        outputs: { type: { response: { ok: { "string-ascii": { length: 32 } }, error: "none" } } }
      },
      getSymbol: {
        name: "get-symbol",
        access: "read_only",
        args: [],
        outputs: { type: { response: { ok: { "string-ascii": { length: 32 } }, error: "none" } } }
      },
      getTokenUri: {
        name: "get-token-uri",
        access: "read_only",
        args: [],
        outputs: {
          type: {
            response: { ok: { optional: { "string-utf8": { length: 256 } } }, error: "none" }
          }
        }
      },
      getTotalSupply: {
        name: "get-total-supply",
        access: "read_only",
        args: [],
        outputs: { type: { response: { ok: "uint128", error: "none" } } }
      },
      hasRole: {
        name: "has-role",
        access: "read_only",
        args: [
          { name: "role-to-check", type: "uint128" },
          { name: "principal-to-check", type: "principal" }
        ],
        outputs: { type: "bool" }
      },
      isBlacklisted: {
        name: "is-blacklisted",
        access: "read_only",
        args: [{ name: "principal-to-check", type: "principal" }],
        outputs: { type: "bool" }
      },
      messageForRestriction: {
        name: "message-for-restriction",
        access: "read_only",
        args: [{ name: "restriction-code", type: "uint128" }],
        outputs: { type: { response: { ok: { "string-ascii": { length: 70 } }, error: "none" } } }
      }
    },
    maps: {
      blacklist: {
        name: "blacklist",
        key: { tuple: [{ name: "account", type: "principal" }] },
        value: { tuple: [{ name: "blacklisted", type: "bool" }] }
      },
      roles: {
        name: "roles",
        key: {
          tuple: [
            { name: "account", type: "principal" },
            { name: "role", type: "uint128" }
          ]
        },
        value: { tuple: [{ name: "allowed", type: "bool" }] }
      }
    },
    variables: {
      BLACKLISTER_ROLE: {
        name: "BLACKLISTER_ROLE",
        type: "uint128",
        access: "constant"
      },
      BURNER_ROLE: {
        name: "BURNER_ROLE",
        type: "uint128",
        access: "constant"
      },
      MINTER_ROLE: {
        name: "MINTER_ROLE",
        type: "uint128",
        access: "constant"
      },
      OWNER_ROLE: {
        name: "OWNER_ROLE",
        type: "uint128",
        access: "constant"
      },
      PERMISSION_DENIED_ERROR: {
        name: "PERMISSION_DENIED_ERROR",
        type: "uint128",
        access: "constant"
      },
      RESTRICTION_BLACKLIST: {
        name: "RESTRICTION_BLACKLIST",
        type: "uint128",
        access: "constant"
      },
      RESTRICTION_NONE: {
        name: "RESTRICTION_NONE",
        type: "uint128",
        access: "constant"
      },
      REVOKER_ROLE: {
        name: "REVOKER_ROLE",
        type: "uint128",
        access: "constant"
      },
      deployerPrincipal: {
        name: "deployer-principal",
        type: "principal",
        access: "variable"
      },
      isInitialized: {
        name: "is-initialized",
        type: "bool",
        access: "variable"
      },
      tokenDecimals: {
        name: "token-decimals",
        type: "uint128",
        access: "variable"
      },
      tokenName: {
        name: "token-name",
        type: {
          "string-ascii": {
            length: 32
          }
        },
        access: "variable"
      },
      tokenSymbol: {
        name: "token-symbol",
        type: {
          "string-ascii": {
            length: 32
          }
        },
        access: "variable"
      },
      uri: {
        name: "uri",
        type: {
          "string-utf8": {
            length: 256
          }
        },
        access: "variable"
      }
    },
    constants: {
      BLACKLISTER_ROLE: 4n,
      BURNER_ROLE: 2n,
      MINTER_ROLE: 1n,
      OWNER_ROLE: 0n,
      PERMISSION_DENIED_ERROR: 403n,
      RESTRICTION_BLACKLIST: 5n,
      RESTRICTION_NONE: 0n,
      REVOKER_ROLE: 3n,
      deployerPrincipal: "SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR",
      isInitialized: false,
      tokenDecimals: 0n,
      tokenName: "",
      tokenSymbol: "",
      uri: ""
    },
    non_fungible_tokens: [],
    fungible_tokens: [{ name: "wrapped-bitcoin" }],
    epoch: "Epoch20",
    clarity_version: "Clarity1",
    contractName: "Wrapped-Bitcoin"
  }
};
var deployments = {
  clarityBitcoin: {
    devnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.clarity-bitcoin",
    simnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.clarity-bitcoin",
    testnet: "STJZ08DQQNGAQ4PWTTNZTD0HDHBWE3J32GMB3HJX.clarity-bitcoin",
    mainnet: null
  },
  ftTrait: {
    devnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.ft-trait",
    simnet: "SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR.ft-trait",
    testnet: "STJZ08DQQNGAQ4PWTTNZTD0HDHBWE3J32GMB3HJX.ft-trait",
    mainnet: null
  },
  magic: {
    devnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.magic",
    simnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.magic",
    testnet: "STJZ08DQQNGAQ4PWTTNZTD0HDHBWE3J32GMB3HJX.magic",
    mainnet: null
  },
  restrictedTokenTrait: {
    devnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.restricted-token-trait",
    simnet: "SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR.restricted-token-trait",
    testnet: "STJZ08DQQNGAQ4PWTTNZTD0HDHBWE3J32GMB3HJX.restricted-token-trait",
    mainnet: null
  },
  testUtils: {
    devnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.test-utils",
    simnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.test-utils",
    testnet: null,
    mainnet: null
  },
  wrappedBitcoin: {
    devnet: "ST1PQHQKV0RJXZFY1DGX8MNSNYVE3VGZJSRTPGZGM.Wrapped-Bitcoin",
    simnet: "SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR.Wrapped-Bitcoin",
    testnet: "STJZ08DQQNGAQ4PWTTNZTD0HDHBWE3J32GMB3HJX.Wrapped-Bitcoin",
    mainnet: "SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR.Wrapped-Bitcoin"
  }
};
var project = {
  contracts,
  deployments
};

// src/utils.ts
import { Address, OutScript } from "@scure/btc-signer";
import { equalBytes as _equalBytes } from "micro-packed";
function outputToAddress(output, network) {
  const outScript = OutScript.decode(output);
  const address = Address(network).encode(outScript);
  return address;
}
function addressToOutput(address, network) {
  const outScript = Address(network).decode(address);
  return OutScript.encode(outScript);
}
function equalBytes(a, b) {
  return _equalBytes(a, b);
}

// src/htlc.ts
import * as btc from "@scure/btc-signer";
import { ripemd160 } from "@noble/hashes/ripemd160";
import { sha256 } from "@noble/hashes/sha256";
import { makeClarityHash } from "micro-stacks/connect";
import {
  contractPrincipalCV,
  intCV,
  standardPrincipalCV,
  tupleCV
} from "micro-stacks/clarity";
var CSV_DELAY = 500n;
var CSV_DELAY_BUFF = btc.CompactSize.encode(CSV_DELAY);
function encodeExpiration(expiration) {
  return typeof expiration === "undefined" ? CSV_DELAY_BUFF : btc.CompactSize.encode(expiration);
}
function createHtlcScript(htlc) {
  return btc.Script.encode([
    htlc.metadata,
    "DROP",
    "IF",
    "SHA256",
    htlc.hash,
    "EQUALVERIFY",
    htlc.recipientPublicKey,
    "ELSE",
    encodeExpiration(htlc.expiration),
    "CHECKSEQUENCEVERIFY",
    "DROP",
    htlc.senderPublicKey,
    "ENDIF",
    "CHECKSIG"
  ]);
}
function encodeHtlcOutput(redeemScript) {
  return btc.OutScript.encode({
    type: "wsh",
    hash: sha256(redeemScript)
  });
}
function hash160(data) {
  return ripemd160(sha256(data));
}
function generateMetadataHash({
  swapperAddress,
  baseFee,
  feeRate
}) {
  const addressCV = swapperAddress.includes(".") ? contractPrincipalCV(swapperAddress) : standardPrincipalCV(swapperAddress);
  const cv = tupleCV({
    swapper: addressCV,
    "fee-rate": intCV(feeRate),
    "base-fee": intCV(baseFee)
  });
  return makeClarityHash(cv);
}

// src/networks.ts
var BtcMainnet = {
  bech32: "bc",
  pubKeyHash: 0,
  scriptHash: 5,
  wif: 128
};
var BtcTestnet = {
  bech32: "tb",
  pubKeyHash: 111,
  scriptHash: 196,
  wif: 239
};
var BtcRegtest = {
  ...BtcTestnet,
  bech32: "bcrt"
};
var BitcoinNetwork = {
  Mainnet: BtcMainnet,
  Testnet: BtcTestnet,
  Regtest: BtcRegtest
};
export {
  BitcoinNetwork,
  BtcMainnet,
  BtcTestnet,
  CSV_DELAY,
  CSV_DELAY_BUFF,
  addressToOutput,
  contracts,
  createHtlcScript,
  deployments,
  encodeExpiration,
  encodeHtlcOutput,
  equalBytes,
  generateMetadataHash,
  hash160,
  outputToAddress,
  project
};
//# sourceMappingURL=index.js.map